export enum LogicalErrorDocumentType {
  Parent = 'P',
  MathBackground = 'B',
  RemediationQuestions = 'Q',
  MisconceptionChart = 'M',
  ResponsiveIntervention = 'R',
  McReteach = 'A',
  McExtension = 'E',
  McChapterOverviewAndProgression = 'C',
  McTeacherResource = 'T',
  McKeyConceptInteractives = 'K',
  McLookingBack = 'L'
}
